// Función para obtener una cookie por su nombre
function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

// Función para establecer una cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Mostrar el banner de cookies si no se ha aceptado
window.onload = function () {
    let cookieBanner = document.getElementById("cookie-banner");
    let acceptCookies = document.getElementById("accept-cookies");

    if (!getCookie("cookiesAccepted")) {
        cookieBanner.style.display = "block";
    }

    acceptCookies.onclick = function () {
        setCookie("cookiesAccepted", "true", 365);
        cookieBanner.style.display = "none";
    }
};